import { render } from "./RoleEdit.vue?vue&type=template&id=ad3d24f4"
import script from "./RoleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/role/components/RoleEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad3d24f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad3d24f4', __exports__)) {
    api.reload('ad3d24f4', __exports__)
  }
  
  module.hot.accept("./RoleEdit.vue?vue&type=template&id=ad3d24f4", () => {
    api.rerender('ad3d24f4', render)
  })

}


export default __exports__